import { useContext } from 'react';
import { TopUpsMutationContext } from '../context/TopUpsMutationContext';

const useTopUpsMutationContext = () => {
  const context = useContext(TopUpsMutationContext);
  if (!context) {
    throw new Error(
      'useTopUpsMutationContext must be used within a TopUpsMutationContextProvider',
    );
  }
  return context;
};

export default useTopUpsMutationContext;
